import { Flex, IconButton, Input, ProgressCircle } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { InputGroup } from "./ui/input-group";
import useDebounce from "hooks/useDebounce";
import { IoMdSearch } from "react-icons/io";

const endElement = (
  <ProgressCircle.Root size="xs" value={null}>
    <ProgressCircle.Circle>
      <ProgressCircle.Track />
      <ProgressCircle.Range strokeLinecap="round" />
    </ProgressCircle.Circle>
  </ProgressCircle.Root>
);

const SearchInput = ({
  onChange,
  loading,
  value,
  type,
  w,
  bg,
  disabled,
  focusRingColor,
  borderColor,
  color,
  fontWeight,
  searchic,
}) => {
  const [svalue, setSvalue] = useState("");
  const debouncedSearch = useDebounce(onChange, 1000);

  const onChangeTxt = (v) => {
    setSvalue(v);
    debouncedSearch(v);
  };

  useEffect(() => {
    setSvalue(value || "");
  }, [value]);

  if (type === "searchV2") {
    return (
      <Input
        placeholder="Search"
        type="text"
        w={w}
        textStyle={"sm"}
        value={svalue}
        onChange={(e) => onChangeTxt(e.target.value)}
        bg={bg || "transparent"}
        disabled={disabled ? true : false}
        color={color || "textv2.base"}
        focusRingColor={focusRingColor || ""}
        borderColor={borderColor || ""}
        fontWeight={fontWeight}
      />
    );
  }

  return (
    <Flex
      maxW="24rem"
      minW="7rem"
      flex={1}
      // w="100%"
    >
      <InputGroup endElement={loading ? endElement : null} flex="1">
        <Input
          placeholder="Search"
          type="text"
          flex={1}
          textStyle="sm"
          value={svalue}
          onChange={(e) => onChangeTxt(e.target.value)}
          color={color || "textv2.base"}
          borderRightRadius="0px"
          focusRingColor={focusRingColor || ""}
          borderColor={borderColor || ""}
          bg={bg || "transparent"}
          fontWeight={fontWeight}
        />
      </InputGroup>

      {searchic === false ? null : (
        <IconButton
          variant="outline"
          borderLeftRadius="0px"
          borderLeftWidth="0px"
          aria-label="Search"
          flexShrink={0}
        >
          <IoMdSearch />
        </IconButton>
      )}
    </Flex>
  );
};

export default SearchInput;
